"use strict";

var _createForOfIteratorHelper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Emitters = void 0;

var EmitterInstance_1 = require("./EmitterInstance");

var Utils_1 = require("../../Utils");

var Emitter_1 = require("./Options/Classes/Emitter");

var Enums_1 = require("./Enums");

var Emitters = /*#__PURE__*/function () {
  function Emitters(container) {
    var _this = this;

    _classCallCheck(this, Emitters);

    this.container = container;
    this.array = [];
    this.emitters = [];
    this.interactivityEmitters = [];
    var overridableContainer = container;

    overridableContainer.getEmitter = function (idxOrName) {
      return idxOrName === undefined || typeof idxOrName === "number" ? _this.array[idxOrName || 0] : _this.array.find(function (t) {
        return t.name === idxOrName;
      });
    };

    overridableContainer.addEmitter = function (options, position) {
      return _this.addEmitter(options, position);
    };

    overridableContainer.playEmitter = function (idxOrName) {
      var emitter = overridableContainer.getEmitter(idxOrName);

      if (emitter) {
        emitter.externalPlay();
      }
    };

    overridableContainer.pauseEmitter = function (idxOrName) {
      var emitter = overridableContainer.getEmitter(idxOrName);

      if (emitter) {
        emitter.externalPause();
      }
    };
  }

  _createClass(Emitters, [{
    key: "init",
    value: function init(options) {
      var _a, _b;

      if (!options) {
        return;
      }

      if (options.emitters) {
        if (options.emitters instanceof Array) {
          this.emitters = options.emitters.map(function (s) {
            var tmp = new Emitter_1.Emitter();
            tmp.load(s);
            return tmp;
          });
        } else {
          if (this.emitters instanceof Array) {
            this.emitters = new Emitter_1.Emitter();
          }

          this.emitters.load(options.emitters);
        }
      }

      var interactivityEmitters = (_b = (_a = options.interactivity) === null || _a === void 0 ? void 0 : _a.modes) === null || _b === void 0 ? void 0 : _b.emitters;

      if (interactivityEmitters) {
        if (interactivityEmitters instanceof Array) {
          this.interactivityEmitters = interactivityEmitters.map(function (s) {
            var tmp = new Emitter_1.Emitter();
            tmp.load(s);
            return tmp;
          });
        } else {
          if (this.interactivityEmitters instanceof Array) {
            this.interactivityEmitters = new Emitter_1.Emitter();
          }

          this.interactivityEmitters.load(interactivityEmitters);
        }
      }

      if (this.emitters instanceof Array) {
        var _iterator = _createForOfIteratorHelper(this.emitters),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var emitterOptions = _step.value;
            this.addEmitter(emitterOptions);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        this.addEmitter(this.emitters);
      }
    }
  }, {
    key: "play",
    value: function play() {
      var _iterator2 = _createForOfIteratorHelper(this.array),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var emitter = _step2.value;
          emitter.play();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      var _iterator3 = _createForOfIteratorHelper(this.array),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var emitter = _step3.value;
          emitter.pause();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.array = [];
    }
  }, {
    key: "update",
    value: function update(delta) {
      var _iterator4 = _createForOfIteratorHelper(this.array),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var emitter = _step4.value;
          emitter.update(delta);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "handleClickMode",
    value: function handleClickMode(mode) {
      var container = this.container;
      var emitterOptions = this.emitters;
      var modeEmitters = this.interactivityEmitters;

      if (mode === Enums_1.EmitterClickMode.emitter) {
        var emitterModeOptions;

        if (modeEmitters instanceof Array) {
          if (modeEmitters.length > 0) {
            emitterModeOptions = Utils_1.Utils.itemFromArray(modeEmitters);
          }
        } else {
          emitterModeOptions = modeEmitters;
        }

        var emittersOptions = emitterModeOptions !== null && emitterModeOptions !== void 0 ? emitterModeOptions : emitterOptions instanceof Array ? Utils_1.Utils.itemFromArray(emitterOptions) : emitterOptions;
        var ePosition = container.interactivity.mouse.clickPosition;
        this.addEmitter(Utils_1.Utils.deepExtend({}, emittersOptions), ePosition);
      }
    }
  }, {
    key: "resize",
    value: function resize() {
      var _iterator5 = _createForOfIteratorHelper(this.array),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var emitter = _step5.value;
          emitter.resize();
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "addEmitter",
    value: function addEmitter(options, position) {
      var emitter = new EmitterInstance_1.EmitterInstance(this, this.container, options, position);
      this.array.push(emitter);
      return emitter;
    }
  }, {
    key: "removeEmitter",
    value: function removeEmitter(emitter) {
      var index = this.array.indexOf(emitter);

      if (index >= 0) {
        this.array.splice(index, 1);
      }
    }
  }]);

  return Emitters;
}();

exports.Emitters = Emitters;